<template>
    <div style="min-height: 600px;">
      <!-- 提交记录 -->
      <el-table
      v-loading="loading"
        :data="list"
        stripe
        style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="submitRecord">
            <el-form label-position="left" inline class="demo-table-expand">
              <pre style="width: 99%; padding-left: 60px;">{{submitRecord.row.code}}</pre>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          label="提交时间"
          width="180">
        </el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          width="180">
        </el-table-column>

        <el-table-column
          prop="language"
          label="语言">
        </el-table-column>

        <el-table-column
          prop="runtime"
          label="运行时间(ms)">
        </el-table-column>

        <el-table-column
          prop="memory"
          label="占用内存(kb)">
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
  import $ from 'jquery'
  
  export default {
    name:'Record',
    data() {
      return {
        loading: true,
        
        record:{},
        list:[],
      }
    },
    mounted() {
      if (this.$store.state.me.id !== "") this.ReadRecord()
      else {
          const t = setInterval(() => {
              if (this.$store.state.me.id !== "") {
                  console.log("我开始hh协议了")
                  this.ReadRecord()
                  clearInterval(t); // 清除定时器
                  console.log("我停止了")
              }
          }, 100);
      }
    },
    methods: {
      ReadRecord() {
        const vue = this  
        const store = this.$store
        const route = this.$route
        console.log("id == ", store.state.me.id)
        $.ajax({
          url: "https://app6132.acapp.acwing.com.cn/jdg/competition/getlist/",
          type: "POST",
          data: ({
            username: store.state.me.id,
            content_id: route.params.pbid,
          }),
          success(resp) {
            console.log(resp);
            vue.record = resp
            vue.list = vue.record.updatelist
            vue.list = vue.list.reverse()
            console.log(vue.list)
            vue.loading = false
          }
        })
      }
    }
  }
</script>

<style>

</style>